<template>
	<div class="modal-overlay" @click="handleOverlayClick">
		<div class="modal-content">
			<div class="modal-header">
				<h3>Upload Document</h3>
				<span class="close" @click="onClose">&times;</span>
			</div>
			<div class="modal-body">
				<LoanDocumentUploader 
					:documentEntityId="documentEntityId"
					:loanId="loanId" 
					:borrowers="borrowers" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { onMounted, onUnmounted } from 'vue';
	import LoanDocumentUploader from '@/components/loan/documents/LoanDocumentUploader.vue';
	import { Borrower } from '@/models/loans';

	const props = defineProps<{
        documentEntityId: number;
		loanId: number;
		borrowers: Borrower[];
		onClose: () => void;
	}>();

	const handleOverlayClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;

		if (target.classList.contains('modal-overlay')) {
			props.onClose();
		}
	};

	onMounted(() => {
		document.body.style.overflow = 'hidden';
	});

	onUnmounted(() => {
		document.body.style.overflow = '';
	});
</script>

<style scoped>
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000000; /* stupid navbar... */
		cursor: default;
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1rem;
	}

	.modal-content {
		position: relative;
		background: white;
		padding: 20px;
		border-radius: 8px;
		min-width: 40vw;
		max-width: 95vw;
		min-height: 60vh;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	}

	.close {
		font-size: 32px;
		cursor: pointer;
		transition: color 0.3s;
	}

	.close:hover {
		color: #888;
	}
</style>
